//import { useState, useEffect } from "react";
import Card from "../UI/Card";
import CryptoItem from "./CryptoItem/CryptoItem";
import classes from "./AvailableCryptos.module.css";

const AvailableCryptos = (props) => {
  console.log("*** AvailableCryptos (props.cryptos) ***");
  console.log(props.cryptos);

  // key={crypto.id} moet EXPLICIET meegegeven worden, anders foutmelding.
  const cryptosList = props.cryptos.map((crypto) => (
    <CryptoItem
      key={crypto.id}
      id={crypto.id}
      naam={crypto.naam}
      aankoophoeveelheid={crypto.aankoophoeveelheid}
      aankoopprijs={crypto.aankoopprijs}
      aankoopdatum={crypto.aankoopdatum}
    />
  ));

  console.log("cryptosList");
  console.log(cryptosList);

  return (
    <section className={classes.meals}>
      <Card>
        <ul>{cryptosList}</ul>
      </Card>
    </section>
  );
};

export default AvailableCryptos;
